/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stx_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why sort by average finishing position instead of total points?`)
};

const es_f1_stx_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué ordenar por posición media de llegada en lugar de puntos totales?`)
};

const de_f1_stx_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum nach durchschnittlicher Zielposition statt nach Gesamtpunkten sortieren?`)
};

const nl_f1_stx_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom sorteren op gemiddelde finishpositie in plaats van totale punten?`)
};

const fr_f1_stx_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi trier par position moyenne à l'arrivée plutôt que par points totaux ?`)
};

const it_f1_stx_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché ordinare per posizione media di arrivo invece che per punti totali?`)
};

const pt_br2_f1_stx_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que ordenar por posição média de chegada em vez de pontos totais?`)
};

const pt_f1_stx_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque ordenar por posição média de chegada em vez de pontos totais?`)
};

const ja_f1_stx_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ合計ポイントではなく平均フィニッシュ順位で並べ替えるのですか？`)
};

const zh_f1_stx_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么要按平均完赛名次而不是总积分排序？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stx_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stx_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stx_faq4_q", locale)
	if (locale === "en") return en_f1_stx_faq4_q(inputs)
	if (locale === "es") return es_f1_stx_faq4_q(inputs)
	if (locale === "de") return de_f1_stx_faq4_q(inputs)
	if (locale === "nl") return nl_f1_stx_faq4_q(inputs)
	if (locale === "fr") return fr_f1_stx_faq4_q(inputs)
	if (locale === "it") return it_f1_stx_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stx_faq4_q(inputs)
	if (locale === "pt") return pt_f1_stx_faq4_q(inputs)
	if (locale === "ja") return ja_f1_stx_faq4_q(inputs)
	return zh_f1_stx_faq4_q(inputs)
};